var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarShapeMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.95702C5.52285 8.95702 9.99954 13.0057 9.99954 18C9.99954 13.0057 14.4772 8.95702 20 8.95702C14.5075 8.95702 10.051 4.95463 9.99954 0C9.94811 4.95546 5.4907 8.95702 0 8.95702Z",
    fill: "#01CDFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarShapeMobile);
export default __webpack_public_path__ + "static/media/star_shape_mobile.c15f5453e5f74dca85eda50ccd8e38e6.svg";
export { ForwardRef as ReactComponent };